(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("theme_megafon", [], factory);
	else if(typeof exports === 'object')
		exports["theme_megafon"] = factory();
	else
		root["theme_megafon"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 